import { z, ZodType } from 'zod';
import { Account } from './account';
import { EntityWithName, entityWithNameSchema } from './entity-with-name';
import { Permissions, permissionsSchema } from './permissions';
import { Wallet, walletSchema } from './wallet';

export type AccountWithWalletsAndPermissions = {
	wallets: Wallet[];
	permissions: Permissions;
	parent?: EntityWithName | null;
} & Account;

export const accountWithWalletsAndPermissionsSchema: ZodType<AccountWithWalletsAndPermissions> =
	z.object({
		id: z.number(),
		name: z.string(),
		note: z.string().nullable(),
		isLocked: z.boolean(),
		createdAt: z.string(),
		wallets: z.array(walletSchema),
		permissions: permissionsSchema,
		parent: entityWithNameSchema.nullable().optional(),
	});
